import React from 'react';
import { SessionCard } from '@morressier/ts';
import { ISessionSearchResult } from 'typings/session';

const SessionCardWrapper: React.FC<ISessionSearchResult> = ({
  name,
  presentedAt,
  startDateTime,
  endDateTime,
  attendeesCount,
  thumbnailUrl,
  featured,
  restricted,
  submissionCount,
  highlightResult
}) => {
  return (
    <SessionCard
      title={name}
      eventName={presentedAt}
      startDateTime={new Date(startDateTime)}
      endDateTime={new Date(endDateTime)}
      attendeesCount={attendeesCount}
      submissionCount={submissionCount}
      isFeatured={featured}
      isRestricted={restricted}
      thumbnailUrl={thumbnailUrl}
      titleHighlightingInformation={highlightResult.name}
      conferenceNameHighlightingInformation={highlightResult.presentedAt}
    />
  );
};

export default SessionCardWrapper;
